import { passThroughAxios } from '@/api/server/passThrough.axios'
import { saveAs } from 'file-saver'
import FileUploadApi from '../api/server/FileUpload.api.js'

const BulkFuturePricesService = {
  async upload(file) {
    try {
      const { token } = await FileUploadApi.uploadToStaging(file)
      const response = await passThroughAxios.post('BulkFuturePrices/upload', null, {
        params: { fileToken: token },
      })
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getFuturePriceJobDetails(jobId) {
    return await passThroughAxios.get(`BulkFuturePrices/job/${jobId}`)
  },
  async prepareForProcessing(jobId) {
    try {
      await passThroughAxios.post(`BulkFuturePrices/job/${jobId}/prepareForProcessing`)
    } catch (error) {
      console.error('Error starting processing:', error)
      throw error
    }
  },
  async downloadResult(jobId) {
    try {
      const response = await passThroughAxios.get(`BulkFuturePrices/job/${jobId}/download`, {
        responseType: 'blob',
      })

      const contentDisposition = response.headers['content-disposition']
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1].split(';')[0]
        : 'result.xlsx'
      let cleanedFileName = filename.replace(/"/g, '') // Remove any extra quotes
      saveAs(response.data, cleanedFileName)
    } catch (error) {
      console.error('Error downloading result:', error)
      throw error
    }
  },
}

export default BulkFuturePricesService
